import * as Yup from "yup";

export const AgreementValidationSchema = Yup.object().shape({
  institution_id: Yup.number()
    .typeError("School / Organization is required")
    .required("School / Organization is required"),

  duration_value: Yup.number()
    .typeError("Duration must be a number")
    .positive("Duration must be greater than 0")
    .test("max-5-digits", "Duration cannot be more than 5 digits", (value) => {
      if (value === undefined || value === null) return true;
      return value.toString().length <= 5;
    })
    .required("Duration is required"),

  base_licenses: Yup.number()
    .typeError("Licenses must be a number")
    .positive("Licenses must be greater than 0")
    .test("max-10-digits", "Licenses cannot be more than 10 digits", (value) => {
      if (value === undefined || value === null) return true;
      return value.toString().length <= 10;
    })
    .required("Licenses is required"),

  duration_unit: Yup.string()
    .oneOf(["year", "month"], "Invalid duration unit")
    .required("Duration unit is required"),

  pricing_type: Yup.string()
    .oneOf(["bulk", "student"], "Invalid pricing type")
    .required("Pricing type is required"),

  price_per_unit: Yup.number().when("pricing_type", {
    is: "bulk",
    then: (schema) =>
      schema
        .typeError("Price must be a number")
        .positive("Price must be greater than 0")
        .min(1, "Price must be at least 1")
        .required("Price per unit is required")
        .test(
          "max-10-digits",
          "Price cannot be more than 10 digits",
          (value) => {
            if (value === undefined || value === null) return true;
            return value.toString().length <= 10;
          },
        )
        .required("Price per unit is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const updateAgreementValidationSchema = AgreementValidationSchema.pick([
  "institution_id",
]);
